import { message, Table } from "antd";
import React, { useEffect, useState } from "react";
import styles from "../../styles/setting.module.scss";
import http from "../../http";

export default function PointsLog() {
  const [logList, setLogList] = useState([] as any);
  const [tableLoading, setTableLoading] = useState(false);
  const [pageData, setPageData] = useState({
    page: 1,
    page_size: 10,
    total: 0,
  });
  const columns = [
    {
      title: "变更类型",
      dataIndex: "change_type",
      key: "change_type",
      with: 150,
    },
    {
      title: "积分",
      dataIndex: "points",
      key: "points",
      with: 150,
      render: (text: string, record: any) => (
        <div>
          {record.sign}
          {text}
        </div>
      ),
    },
    {
      title: "描述",
      dataIndex: "description",
      key: "description",
      with: 150,
    },
    {
      title: "变更时间",
      dataIndex: "update_timestamp",
      key: "update_timestamp",
      with: 150,
    },
  ];
  useEffect(() => {
    getLog(pageData);
  }, []);
  const getLog = (pageData: {
    page: number;
    page_size: number;
    total: number;
  }) => {
    setTableLoading(true);
    http
      .post(
        `/api/v1/points/record?page=${pageData.page}&page_size=${pageData.page_size}`
      )
      .then((res: any) => {
        if (res.status) {
          setLogList(res.data.items);
          setPageData({ ...pageData, total: res.data.total });
          setTableLoading(false);
        } else {
          message.error(res.message);
          setTableLoading(false);
        }
      });
  };
  return (
    <div className={styles.wraper}>
      <Table
        dataSource={logList}
        style={{ width: "100%" }}
        scroll={{ y: 450 }}
        size="small"
        columns={columns}
        loading={tableLoading}
        rowKey={"uuid"}
        pagination={{
          position: ["bottomRight"],
          total: pageData.total,
          current: pageData.page,
          pageSize: pageData.page_size,
          onChange(page, pageSize) {
            const newpage = {
              ...pageData,
              page,
              page_seze: pageSize,
            };
            setPageData(newpage);
            getLog(newpage);
          },
        }}
      />
    </div>
  );
}
